import React, { useEffect, useState } from 'react';
import PropTypes, {arrayOf} from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import EmailTemplateCreateTab from './EmailTemplateCreateTab';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import {emailTemplateType, productType} from '../../types';

CreateEmailTemplateRow.propTypes = {
    availableProducts: arrayOf(productType),
    cloneSource: emailTemplateType,
    onCloneHandled: PropTypes.func,
};

function CreateEmailTemplateRow(props) {
    const {
        availableProducts,
        cloneSource = null,
        onCloneHandled = () => {}
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const [initialTemplate, setInitialTemplate] = useState(null);

    useEffect(() => {
        if (cloneSource) {
            setInitialTemplate(cloneSource);
            setCreateVisible(true);
            onCloneHandled();
        }
    }, [cloneSource, onCloneHandled]);

    const actionHandler = () => {
        setInitialTemplate(null);
        setCreateVisible(!isCreateVisible);
    };
    const hideHandler = () => {
        setInitialTemplate(null);
        setCreateVisible(false);
    };

    return (
        <div className="create-email-template-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}>
                <FontAwesomeIcon icon="plus" />&nbsp;{t('email-templates.create-email-template')}
            </CreateButton>
            {isCreateVisible && (
                <EmailTemplateCreateTab
                    availableProducts={availableProducts}
                    hideHandler={hideHandler}
                    initialTemplate={initialTemplate}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.EMAIL_TEMPLATE_EDIT])(CreateEmailTemplateRow);
